export default __webpack_public_path__ + "static/media/ReleaseNotes_Macropoint_Updates1.c99e2023.png";